import React from "react";
import Home from "../components/home/Home";

const HomePage = () => {
  return (
    <section id="home">
      <Home />
    </section>
  );
};

export default HomePage;
